import { PayloadAction } from '@reduxjs/toolkit';

import { ProductPersonalizerState } from 'product-personalizer/src/store/productPersonalizer/slice';

const setProductImagesReducer = (state: ProductPersonalizerState, action: PayloadAction<string[]>) => {
  state.productImages = action.payload;
};

export default setProductImagesReducer;
